import CircularProgress from '../CircularProgress/CircularProgress';
import styles from './LoadingOverlay.module.scss';

/**
 * LoadingOverlay 컴포넌트
 * - 전체 영역 또는 상위 컨테이너를 덮는 로딩 오버레이
 * @param {string} message - 로딩 메시지
 * @param {boolean} isFullPage - 전체 화면 여부 (fixed vs absolute)
 * @param {string} backgroundColor - 배경색 (rgba 지원)
 */
export default function LoadingOverlay({
  message = '로딩 중...',
  isFullPage = false,
  backgroundColor = 'rgba(255, 255, 255, 0.7)',
}) {
  return (
    <div
      className={`${styles.overlay} ${isFullPage ? styles.fullPage : styles.absolute}`}
      style={{ backgroundColor }}
    >
      <div className={styles.content}>
        <CircularProgress size={32} />
        {message && <div className={styles.message}>{message}</div>}
      </div>
    </div>
  );
}
